import { concat, flatten, map, pipe, values } from 'ramda'
import { useMemo, useState } from 'react'
import { createContainer } from 'unstated-next'
import useSWR from 'swr'
import { slsPublicBaseUrl } from '../../../API/config'

const uniqid = require('uniqid')

const ArtistInfoStore = createContainer((initialData) => {
  const [livdemyId, updateLivdemyId] = useState('')

  const { data = initialData, error } = useSWR(
    livdemyId ? `${slsPublicBaseUrl}/teacher/profile/${livdemyId}` : null,
  )

  const classes = useMemo(
    () =>
      pipe(
        values,
        flatten,
        concat(data?.recordedCourses || []),
        concat(data?.liveCourses || []),
        map((item) => ({
          ...item,
          id: item.id || uniqid(),
          startTime: 0,
          endTime: 0,
        })),
      )(data?.broadcastClasses || {}),
    [data],
  )

  return {
    livdemyId,
    data,
    loading: !data && !error,
    loadFailed: Boolean(error) && !data,
    updateLivdemyId,
    classes,
  }
})

export default ArtistInfoStore
